<template>
  <div>
    <el-dialog
      title="提现申请"
      v-model="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
          ref="formRef"
            :model="formData"
            :rules="rules"
            label-width="100px"
            style="margin-top: 20px"
          >
            <el-form-item label="姓名" prop="payeeName">
              <el-input
                v-model="formData.payeeName"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="支付宝账号" prop="payeeAccount">
              <el-input
                v-model="formData.payeeAccount"
                placeholder="请输入支付宝账号"
              ></el-input>
            </el-form-item>
            <el-form-item label="面试币数量" prop="transferAmount">
              <el-input
                v-model="formData.transferAmount"
                placeholder="请输入面试币数量"
                type="number"
                :min="0"
                :max="refundAmount"
                @blur="validateTransferAmount"
              ></el-input>
            </el-form-item>
      </el-form>
      <div class="refund-content">
        <p>您当前可退 <span class="refund-amount">{{ refundAmount }}面试币 = {{ refundAmount }}人民币</span></p>
        <p class="refund-note">
          已剔除余额中通过活动邀请赠送的部分，邀请赠送的积分不可退
        </p>
        <p class="refund-rules">
          退费规则说明：退款将实时退回您的原支付账户，如未收到，请<a href="#" @click.prevent="contactUs">联系我们</a>
        </p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="applyRefund">提交</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      title="确认退款"
      v-model="confirmVisible"
      width="30%"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="confirm-content">
        <p>是否确认提交退费申请，申请成功后退款将实时返回您的支付账户</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="confirm">确认</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="退款成功"
      v-model="successVisible"
      width="30%"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="success-content">
        <p>您的退款申请成功，退款将实时返回原支付账户，如未收到，请<a href="#" @click.prevent="contactUs">联系我们</a></p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="goBack">返回个人中心</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {transfer} from "@/api/interview";
import { getUserInfo } from "@/api/login/login";
export default {
  props: {
    currentBalance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      formData: {
        payeeName: '',
        payeeAccount: '',
        transferAmount: ''
      },
      dialogVisible: false,
      refundAmount: 0, // 用户当前可提现的面试币数量
      confirmVisible: false,
      successVisible: false,
      rules: {
        payeeName: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        payeeAccount: [
          { required: true, message: "请输入支付宝账号", trigger: "blur" }
        ],
        transferAmount: [
          { required: true, message: "请输入提现数量", trigger: "blur" },
          { 
            validator: (rule, value, callback) => {
              const transferAmount = parseFloat(value);
              if (isNaN(transferAmount) || transferAmount <= 0) {
                callback(new Error('请输入有效的面试币数量'));
              } else if (transferAmount > this.refundAmount) {
                callback(new Error(`提现数量不能超过当前可用余额（${this.refundAmount}面试币）`));
              } else {
                callback();
              }
            }, 
            trigger: "blur" 
          }
        ]
      }
    };
  },
  methods: {

    async show() {
      this.dialogVisible = true;
      // 打开弹窗时查询用户当前面试币
      await this.queryUserBalance();
    },
    // 查询用户当前面试币
    async queryUserBalance() {
      try {
        const response = await getUserInfo({});
        if (response.code === 200 && response.data) {
          // 更新可提现面试币数量
          this.refundAmount = response.data.balance || 0;
        }
      } catch (error) {
        console.error('查询用户面试币失败:', error);
      }
    },
    async applyRefund() {
      // 调用表单校验
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 校验通过，执行提现逻辑
          this.submitRefund();
        } else {
          // 校验不通过，提示错误（Element UI 会自动显示表单项的错误信息）
          this.$message.error('请填写正确信息');
          return false;
        }
      });
    },
    async submitRefund() {
      // 处理申请退款的逻辑，按照接口文档调整参数
      const obj = {
        userId: "", // 线上不用传，后端可以通过token获取useId
        transferAmount: this.formData.transferAmount, // 单位：面试币个数
        payeeType: "ALIPAY_LOGONID", // 必填，固定填 ALIPAY_LOGONID
        payeeAccount: this.formData.payeeAccount, // 必填，支付宝登录账号
        payeeName: this.formData.payeeName // 必填，支付宝实名
      };
      
      transfer(obj).then((res) => {
        console.log('原始返回数据:', res);
        
        // 解析 TransferResultVo 字符串为对象
        let transferResult = {};
        try {
          if (typeof res === 'string') {
            // 如果是字符串，尝试解析 TransferResultVo 格式
            const match = res.match(/TransferResultVo\{([^}]+)\}/);
            if (match) {
              const content = match[1];
              const pairs = content.split(', ');
              pairs.forEach(pair => {
                const [key, value] = pair.split('=');
                if (key && value !== undefined) {
                  // 处理值，去除引号并转换类型
                  let cleanValue = value.replace(/^'|'$/g, ''); // 去除单引号
                  if (cleanValue === 'null') {
                    cleanValue = null;
                  } else if (cleanValue === 'true') {
                    cleanValue = true;
                  } else if (cleanValue === 'false') {
                    cleanValue = false;
                  } else if (!isNaN(cleanValue)) {
                    cleanValue = Number(cleanValue);
                  }
                  transferResult[key] = cleanValue;
                }
              });
            }
          } else {
            // 如果已经是对象，直接使用
            transferResult = res;
          }
        } catch (error) {
          console.error('解析 TransferResultVo 失败:', error);
          transferResult = res; // 解析失败时使用原始数据
        }
        
        console.log('解析后的数据:', transferResult);
        console.log('success 值:', transferResult.success);
        
        if (transferResult.success === true) {
          this.$message.success('提现申请已提交，会在两个工作日内到账，请耐心等待');
          this.dialogVisible = false;
          // 清空表单
          this.formData = {
            payeeName: '',
            payeeAccount: '',
            transferAmount: ''
          };
          // 刷新用户余额
          this.queryUserBalance();
          // 触发父组件刷新用户信息事件
          this.$emit('refresh-balance');
        } else {
          // 返回错误信息
          this.$message.error('提现失败，请稍后再试');
        }
      }).catch((error) => {
        console.error('提现请求失败:', error);
        this.$message.error('提现失败，请稍后再试');
      });
    },
    // 验证提现金额
    validateTransferAmount() {
      const transferAmount = parseFloat(this.formData.transferAmount);
      if (!isNaN(transferAmount) && transferAmount > this.refundAmount) {
        this.$message.warning(`提现数量不能超过当前可用余额（${this.refundAmount}面试币）`);
      }
    },
    contactUs() {
      // 处理联系我们的逻辑
      console.log('联系我们');
    },
    show2() {
      this.confirmVisible = true;
    },
    cancel() {
      this.confirmVisible = false;
    },
    confirm() {
      // 处理确认退款的逻辑
      console.log('确认退款');
      this.confirmVisible = false;
      this.show3();
    },
    show3() {
      this.successVisible = true;
    },
    goBack() {
      this.successVisible = false;
    //   this.$emit('go-back');
    }
  }
};
</script>

<style scoped>
.refund-content {
  text-align: center;
}

.refund-amount {
  color: red;
  font-weight: bold;
}

.refund-note {
  margin: 10px 0;
  font-size: 12px;
  color: gray;
}

.refund-rules {
  margin: 10px 0;
  font-size: 12px;
  color: gray;
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .refund-content {
    padding: 20px 16px;
  }
  
  .refund-amount {
    font-size: 18px;
  }
  
  .refund-note,
  .refund-rules {
    font-size: 11px;
    margin: 8px 0;
  }
  
  .el-form-item {
    margin-bottom: 16px;
  }
  
  .el-form-item__label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  
  .el-input__inner {
    height: 40px;
    font-size: 14px;
  }
  
  .el-button {
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
  }
  
  .dialog-footer {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
  
  .dialog-footer .el-button {
    width: 100%;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .refund-content {
    padding: 24px 20px;
  }
  
  .refund-amount {
    font-size: 20px;
  }
  
  .refund-note,
  .refund-rules {
    font-size: 12px;
    margin: 10px 0;
  }
  
  .el-form-item__label {
    font-size: 15px;
  }
  
  .el-input__inner {
    height: 42px;
    font-size: 15px;
  }
  
  .el-button {
    padding: 12px 24px;
    font-size: 15px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .refund-content {
    padding: 16px 12px;
  }
  
  .refund-amount {
    font-size: 16px;
  }
  
  .refund-note,
  .refund-rules {
    font-size: 10px;
    margin: 6px 0;
  }
  
  .el-form-item {
    margin-bottom: 12px;
  }
  
  .el-form-item__label {
    font-size: 13px;
    margin-bottom: 4px;
  }
  
  .el-input__inner {
    height: 38px;
    font-size: 13px;
  }
  
  .el-button {
    padding: 10px 16px;
    font-size: 15px;
  }
  
  .dialog-footer {
    margin-top: 12px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .refund-content {
    padding: 20px 16px;
  }
  
  .refund-amount {
    font-size: 18px;
  }
  
  .refund-note,
  .refund-rules {
    font-size: 11px;
    margin: 8px 0;
  }
  
  .el-form-item {
    margin-bottom: 14px;
  }
  
  .el-form-item__label {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .el-input__inner {
    height: 36px;
    font-size: 14px;
  }
  
  .el-button {
    width: auto;
    padding: 10px 20px;
    font-size: 14px;
  }
  
  .dialog-footer {
    margin-top: 14px;
  }
  
  .dialog-footer .el-button {
    width: auto;
  }
}
</style>